'use client';

import { useState, useEffect } from 'react';
import { useHeaderSlot } from '@/lib/dashboard/header-slot-context';
import { HeaderSearchInput } from '@/components/layout/HeaderSearchInput';
import { createElement } from 'react';

interface UseHeaderSearchOptions {
  placeholder: string;
  ariaLabel: string;
  debounceMs?: number;
}

interface UseHeaderSearchResult {
  searchQuery: string;
  searchInput: string;
  setSearchInput: (value: string) => void;
  clearSearch: () => void;
}

export function useHeaderSearch({
  placeholder,
  ariaLabel,
  debounceMs = 200,
}: UseHeaderSearchOptions): UseHeaderSearchResult {
  const { setCenterSlot } = useHeaderSlot();
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  // Debounce raw input into committed query
  useEffect(() => {
    const t = setTimeout(() => setSearchQuery(searchInput), debounceMs);
    return () => clearTimeout(t);
  }, [searchInput, debounceMs]);

  // Register / update search input in header center slot
  useEffect(() => {
    setCenterSlot(
      createElement(HeaderSearchInput, {
        value: searchInput,
        onChange: setSearchInput,
        placeholder,
        ariaLabel,
      })
    );
    return () => setCenterSlot(null);
  // placeholder and ariaLabel are static per page — intentionally excluded
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  const clearSearch = () => {
    setSearchInput('');
    setSearchQuery('');
  };

  return { searchQuery, searchInput, setSearchInput, clearSearch };
}
